import { useState } from 'react';
import { FaDesktop, FaExpandArrowsAlt, FaGlobe, FaMobileAlt } from 'react-icons/fa';
import Modal from './Modal';
import styles from './AppDemoPreview.module.css';

function BrowserCapture({ demo, expanded = false }) {
  const domain = new URL(demo.url).hostname.replace(/^www\./, '');

  return (
    <span className={styles.browserFrame}>
      <span className={styles.browserBar} aria-hidden="true">
        <span className={styles.browserDots}><i /><i /><i /></span>
        <span className={styles.browserAddress}>{domain}</span>
        <FaGlobe />
      </span>
      <span className={expanded ? styles.fullScreen : styles.previewScreen}>
        <img
          src={demo.preview.desktop}
          alt={`Desktop preview of ${demo.title}`}
          width="1440"
          height={demo.preview.desktopHeight}
          loading={expanded ? 'eager' : 'lazy'}
          decoding="async"
        />
      </span>
    </span>
  );
}

function AppDemoPreview({ demo }) {
  const [isOpen, setIsOpen] = useState(false);
  const [device, setDevice] = useState('desktop');

  const openPreview = () => {
    setDevice('desktop');
    setIsOpen(true);
  };

  return (
    <>
      <button
        type="button"
        className={styles.previewButton}
        onClick={openPreview}
        aria-label={`View ${demo.title} preview`}
        aria-haspopup="dialog"
      >
        <BrowserCapture demo={demo} />
        <span className={styles.previewCaption}>
          <span>{demo.preview.label}</span>
          <span className={styles.expandLabel}>Enlarge <FaExpandArrowsAlt aria-hidden="true" /></span>
        </span>
      </button>

      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} title={`Preview: ${demo.title}`}>
        <div className={styles.previewDetails}>
          <p className={styles.eyebrow}>{demo.preview.label}</p>
          <h2>{demo.title}</h2>
          <div className={styles.deviceSwitch} role="group" aria-label="Preview device">
            <button type="button" aria-pressed={device === 'desktop'} onClick={() => setDevice('desktop')}>
              <FaDesktop aria-hidden="true" /> Desktop
            </button>
            <button type="button" aria-pressed={device === 'mobile'} onClick={() => setDevice('mobile')}>
              <FaMobileAlt aria-hidden="true" /> Mobile
            </button>
          </div>

          <div className={styles.expandedPreview}>
            {device === 'desktop' ? (
              <BrowserCapture demo={demo} expanded />
            ) : (
              <div className={styles.phoneFrame}>
                <span className={styles.phoneCamera} aria-hidden="true" />
                <img
                  src={demo.preview.mobile}
                  alt={`Mobile preview of ${demo.title}`}
                  width="390"
                  height="844"
                  decoding="async"
                />
                <span className={styles.phoneHome} aria-hidden="true" />
              </div>
            )}
          </div>

          <a className={styles.openApp} href={demo.url} target="_blank" rel="noopener noreferrer">
            Open {demo.title} <FaGlobe aria-hidden="true" />
          </a>
        </div>
      </Modal>
    </>
  );
}

export default AppDemoPreview;
